<template>
  <div class="position">
    <van-image width="100%" height="100%" :src="imgUrl" />
    <div>404错误</div>
    <div>系统正在努力完善中...</div>
    <router-link class="button" to="/">返回首页</router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrl: require("../assets/err/404.png")
    };
  }
};
</script>
<style lang="scss" scoped>
.position {
  // border:1px solid red;
  text-align: center;
  color: #999;
  margin-top:300px;
  .button {
      margin-top:50px;
      display: inline-block;
      background:#E21111;
      color:#fff;
      font-size: 30px;
      line-height: 60px;
      border-radius: 50px;
      padding:0 50px;
  }
}
</style>